import { RM04_04 } from "./RM04_04";

export const RM04_03 = {
  selectedValueColumn: "DrillKey",
  selectedTitle: "Territory",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Territory",
        binding: {
          data: {
            columns: [
              {
                name: "TER Name",
                columnName: "TERName",
                width: "300px",
                align: "left",
                sortable: true,
                sum: false,
              },
              {
                name: "Territory Name",
                columnName: "TerritoryName",
                width: "300px",
                align: "left",
                sortable: true,
                sum: false,
              },
              {
                name: "Number Of Branches",
                columnName: "NumberOfBranches",
                width: "300px",
                align: "center",
                sortable: true,
                sum: false,
              },
            ],
            title: "TerritoryName",
            endpoint: "RM04.3",
            parameters: [
              { key: "FromMonth", value: "CP1" },
              { key: "FromYear", value: "2026" },
              { key: "ToMonth", value: "CP1" },
              { key: "ToYear", value: "2026" },
              { key: "RegionCode", value: "" },
              { key: "DrillKey", value: "" },
            ],
          },
          context: {
            point: {
              onClick: RM04_04,
            },
          },
        },
      },
    },
  ],
};
